module.exports = __webpack_public_path__ + "img/btn_google_signin_light_normal_web.52a05e73.png";